import styles from "./StarInput.module.css";

const STARS = [1, 2, 3, 4, 5];

export default function StarInput({ value, onChange }) {
  return (
    <div role="radiogroup" aria-label="Rating" className={styles.group}>
      {STARS.map((n) => (
        <button
          type="button"
          key={n}
          role="radio"
          aria-checked={value === n}
          aria-label={`${n} star${n > 1 ? "s" : ""}`}
          className={`${styles.star} ${n <= value ? styles.filled : ""}`}
          onClick={() => onChange(n)}
        >
          ★
        </button>
      ))}
    </div>
  );
}
